/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'ロードしています...',
	'dlg_close': '閉じる',
	'dlg_ok': 'OK',
	'dlg_cancel': 'キャンセル',
	'dlg_back': '戻る',
	'dlg_done': '完了',

	// Slider
	'sliderRegionLabel': 'スライダー・コントロール。スライダー・ハンドルを移動するには左右の矢印キーを使用します',
	'sliderHandleLabel': 'スライダー・ハンドル',
	'a11ySliderHandleLabel': 'スライダー・ハンドル %{sliderValue}',
	'sliderInputLabel': '値',

	// Side bar
	'sidebarAdd': '追加',
	'clearTextFilterValue': 'クリア',
	'missingDataSetData': 'このデータ・セットのデータは使用できません。 このデータ・セットを更新するか、または管理者に連絡して、ソースにアクセスできるようにしてください。',

	// Toolbar
	'toolbarRegionLabel': 'ツールバー',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'フォント・ファミリー',
	'fontSizeSelect': 'フォント・サイズ',
	'fontColorSelect': '色',
	'fontStyle': 'スタイル',
	'colorPickerTitle': 'カラーの選択',
	'bold': '太字',
	'italic': '斜体',
	'underline': '下線',
	'fontAlignment': '位置揃え',
	'justifyLeft': '左揃え',
	'justifyCenter': '中央揃え',
	'justifyRight': '右揃え',
	'insertOrderedList': '順番付けしたリスト',
	'insertUnorderedList': '順番付けのないリスト',
	'fontColorPicker': 'カラー・ピッカー',
	'textWrap': 'テキストを折り返し',
	'restore': 'デフォルトに戻す',
	// Top Bottom
	'topbottomNumberOfResultsLabel': '結果数 (%{lower} - %{higher})',
	'topbottomPercentLabel': 'パーセント (%{lower}% - %{higher}%)',
	'topbottomSelectOption': '上位または下位オプション',
	'topbottomOptionLabel': '表示',
	'searchByLabel': '次のラベルで検索',
	'searchNoMatches': '一致が見つかりません',
	'topbottomRankColumnLabel': 'ランク列を表に追加',
	'topbottomNone': 'なし',
	'topCount': '上位件数',
	'topPercent': '上位 %',
	'bottomCount': '下位件数',
	'bottomPercent': '下位 %',
	'searchColumn': '列の検索',
	'searchColumnAriaLabel': '列を検索します。 検索する列の名前を入力してから、リストで下矢印を使用して該当列を見つけます。',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'ランク (%{columnLabel})',
	'topbottomClearLabel': 'リセット',

	// Format
	'formatAuto': '自動',
	'formatConvertPercent': '10 進数をパーセントに変換',
	'formatAbbreviate': '簡略',
	'formatUseGrouping': '桁区切り記号を使用',
	'dateStyle': '日付の形式',
	'dateTimeStyle': '日付/時刻の形式',
	'formatMissingValueCharactersInfo': '欠落値の文字は、値が欠落している場合に表示される文字を指定します。',
	'currencySymbolLabel': '通貨記号',
	'customSymbolPlaceholder': 'シンボルの追加',
	'customSymbolLabelInfo': 'カスタム・シンボルとして使用する文字 (複数可) を指定します。この記号は、数値とあらゆる符号の前に表示されます。',
	'numberLabel': '数値ラベル',
	'numberPositionLabel': 'ラベル位置',
	'numberLabelInfo': 'フォーマットされた数値のラベルを指定し、ラベルの位置に応じて接頭部または接尾部として配置します。',
	'nullValueDefault': '<デフォルト>',
	'nullValueContent': '(値なし)',
	'default': 'デフォルト',
	'beginning': '先頭',
	'end': '末尾',
	'formatLabel': 'フォーマットの選択',

	// More data indicator
	'moreDataIndicator': 'データは %{threshold} アイテムの位置で切り取られました。より少ない表示にするにはフィルターを適用します。',

	// Expanded View / Focus mode
	'evCollapse': '省略',
	'duplicate': '複製',
	'copyOf': '%{name}のコピー',
	'unableToDuplicateBoard': '"%{name}" を複製できません。',

	// Widget list
	'errorLoadingWidgetList': 'オブジェクトをロードできません。',

	// Custom widgets
	'customWidget': 'カスタム・ウィジェット'
});
